import Common from './Common'
import BaseInfo from './BaseInfo'
import Collection from './Collection'
import Monitor from './Monitor'
import Analysis from './Analysis'
import Model from './Model'
import Report from './Report'
import Admin from './Admin'

// v0.5 잔여 API 확인 후 추가 정리
import FdcEqpInfo from './FdcEqpInfo'
import FdcPreproc from './FdcPreproc'
import FdcFaultActionPlan from './FdcFaultActionPlan'
import FdcCollectionPlan from './FdcCollectionPlan'
import FdcAnalysisReport from './FdcAnalysisReport'
import FdcManagement from './FdcManagement'

export default {
  Common: Common,
  BaseInfo: BaseInfo,
  Collection: Collection,
  Monitor: Monitor,
  Analysis: Analysis,
  Model: Model,
  Report: Report,
  Admin: Admin,

  // v0.5 잔여 API 추후 추가 정리
  FdcEqpInfo: FdcEqpInfo,
  FdcPreproc: FdcPreproc,
  FdcFaultActionPlan: FdcFaultActionPlan,
  FdcCollectionPlan: FdcCollectionPlan,
  FdcAnalysisReport: FdcAnalysisReport,
  FdcManagement: FdcManagement
}
